import { render } from "./SNotification.vue?vue&type=template&id=3f771049&scoped=true&ts=true"
import script from "./SNotification.ts?vue&type=script&lang=ts"
export * from "./SNotification.ts?vue&type=script&lang=ts"

import "./SNotification.scss?vue&type=style&index=0&id=3f771049&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f771049"]])

export default __exports__